module.exports = __webpack_public_path__ + "img/mp2.de2ec723.svg";